import { Injectable } from "@angular/core";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})

export class PdaService {
    constructor(private http: CommonHttpModule) { }

    // method to post the PDA data to DB
    postPdaData(data: any): Observable<any> {
        return this.http.post("initiate_disbursement_manual", data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    // method to get PDA data from DB
    getPdaData(data: any): Observable<any> {
        return this.http.post<{ total_count: number, data: any[] }>("pdadata", data)
            .pipe(
                map(response => {
                    return response.data;
                })
            );
    }


    pdaCreateByPortAgent(data: any): Observable<any> {
        return this.http.post("initiate_disbursement", data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    pdaEditFormData(data: any): Observable<any> {
        return this.http.get(`disbursement_detail/${data}`, {}).pipe(
            map((response) => {
                return response;
            })
        );
    }


    pdaEditDataToDb(data: any): Observable<any> {
        return this.http.post('pda_edit', data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    reRequestPda(data: any): Observable<any> {
        return this.http.post('re_request', data).pipe(
            map((response) => {
                return response;
            })
        );
    }
    clientRequestPda(data: any): Observable<any> {
        return this.http.post('client_approval_request', data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    pdaReCalculate(data: any): Observable<any> {
        return this.http.post('recalculate_disbursement', data).pipe(
            map((response) => {
                return response;
            })
        );
    }


    clientRequestfda(data: any): Observable<any> {
        return this.http.post('FDA_client_approval_request', data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    resendPdaLink(data: any): Observable<any> {
        return this.http.post('resend_pda_link', data).pipe(
            map((response) => {
                return response;
            })
        );
    }
}